/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GroupConfigurationRequest
 */
export interface GroupConfigurationRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof GroupConfigurationRequest
     */
    cmGroupIds: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof GroupConfigurationRequest
     */
    groupId?: number;
}

/**
 * Check if a given object implements the GroupConfigurationRequest interface.
 */
export function instanceOfGroupConfigurationRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "cmGroupIds" in value;

    return isInstance;
}

export function GroupConfigurationRequestFromJSON(json: any): GroupConfigurationRequest {
    return GroupConfigurationRequestFromJSONTyped(json, false);
}

export function GroupConfigurationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupConfigurationRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cmGroupIds': json['cmGroupIds'],
        'groupId': !exists(json, 'groupId') ? undefined : json['groupId'],
    };
}

export function GroupConfigurationRequestToJSON(value?: GroupConfigurationRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cmGroupIds': value.cmGroupIds,
        'groupId': value.groupId,
    };
}

